import { Record } from 'immutable';
import { LiveStream } from 'typings/types';

interface LiveStreamsInterface {
  data: LiveStream[];
  error: string | null;
  isFetching: boolean;
}

export const initialState: LiveStreamsInterface = {
  data: [],
  error: null,
  isFetching: false
};

export class LiveStreamsState extends Record(initialState) {
}
